import _ from 'lodash'

import { defaultInstance } from 'services'

import { responseSuccess, responseError } from 'utils/response'

export const mapBuFilter = (item) => {
  return {
    id: item?.bu_id,
    name: item?.bu_name,
    abbr: item?.bu_abbr,
    cd: item?.bu_cd,
    is_pool: item?.is_pool,
  }
}

export const getBuApi = () => {
  const config = {
    method: 'get',
    url: '/api/v1/filters/business_unit',
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (_.size(res.data) >= 0 && _.isArray(res.data)) {
        return responseSuccess({ data: _.map(res.data, mapBuFilter) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
